<!--
================================================
Une view affichant le détail d'un projet
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <app-layout-comp>
    <div slot="AppContent" id="ProjectDetailsView" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
      <!-- Modale project ----------------------------------------------->
      <modal-project-management-comp></modal-project-management-comp>

      <div class="" v-if="componentIsReady">
        <div class="columns is-mobile is-centered">

          <div class="column is-narrow noPrint">
            <router-link v-bind:to="{ name: 'projects', params: {locale: locale}}"
                         class="button  cronoBtn invert backProjects" :title="$t('retourAuxProjets')">
                       <span class="icon">
                         <font-awesome-icon :icon="['fas', 'arrow-left']" class=""/>
                      </span>
              <span>{{ $t('projets') }}</span>
            </router-link>
          </div>
          <div class="column"></div>
          <div class="column is-narrow noPrint">
            <a id="editBtn" class="button cronoBtn ">
              <!--              <span class="icon"><font-awesome-icon :icon="['fas', 'pencil-alt']" class=""/></span>-->
              <span v-on:click="modifyProject(project)">{{ $t('modifierLeProjet') }}</span>
            </a>

            <a id="printBtn" class="button cronoBtn " v-on:click="printPage()" v-bind:title="$t('imprimer')">
              <span class="icon"><font-awesome-icon :icon="['fas', 'print']" class=""/></span>
            </a>
          </div>
        </div>

      </div>

      <div v-if="!componentIsReady" class="compLoader">
        <spinner-loader-comp v-bind:loading-txt="$t('chargement')"></spinner-loader-comp>
      </div>
      <div v-else class="contentComponentIsReady">
        <!-- TITRE DU PROJET -->
        <div class="columns is-centered">

          <div class="column  projectNamePart">
            <div class="projectName">
              <font-awesome-icon v-if="!project.isArchived" v-bind:style="{color:'#'+ project.color}" class="icon"
                                 :icon="['far', 'folder-open']"/>
              <font-awesome-icon v-else class="icon" :icon="['fas', 'folder']"/>
              {{ project.name }}
              <span class="archivedMention" v-if="project.isArchived">({{ $t('archivé') }})</span>

            </div>

            <div class="clientName" v-if="project.client!=null">
              <font-awesome-icon :icon="['fas', 'user-tie']" class="icon"/>
              {{ project.client.name }}
            </div>
          </div>
        </div>

        <h3 class="subTitlePrint printOnly">{{ $t("ChiffresClésAu", {date: $moment().format('LLL')}) }}</h3>
        <h3 class="subTitle noPrint">{{ $t("LesInformationsEssentiellesDeVotreProjet") }}</h3>

        <div class="box px-0 py-0 upgradeMsg" v-if="premiumLimitation">
          <div class=" message is-warning has-text-center">

            <div class="message-body">
              <p class="is-size-6 has-text-weight-bold has-text-warning-dark">
                <font-awesome-icon class="icon" :icon="['fas', 'exclamation-circle']" size="1x" />
                {{$t("LesDonnéesAffichéesSontDesDonnéesDeDémonstration")}}</p>

              <p class="has-text-grey">
                <span v-html="$t('PourSuivreVosProjetsEnTempsRéelMettezÀJour')" ></span>
                <router-link class="ml-2 has-text-link has-text-weight-bold is-underlined upgradeLink"
                             v-bind:to="{ name: 'workspace-subscription',params:{locale:locale,organization:organizationSlug, workspace:$auth.getActiveWorkspace()},query:{cycle:'month',pgr:planGroup4Locale}}">
                  <span>{{ $t('MettreÀNiveau') }}</span>
                  <font-awesome-icon class="icon ml-1 pt-2 is-size-5" :icon="['fas', 'medal']"/>
                </router-link>
              </p>

            </div>

          </div>


        </div>



        <project-kpi-comp v-bind:project="project,isDemoMode" ></project-kpi-comp>
      </div>


    </div>
  </app-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
// @ is an alias to /src
import AppLayoutComp from '@/components/AppLayoutComp.vue'
import VueMetaMixin from "../mixins/VueMetaMixin.js";
import SentryMixin from "../mixins/SentryMixin.js";
import InterceptorMixin from "../mixins/InterceptorMixin.js";
import GlobalErrorNotificationMixin from "../mixins/GlobalErrorNotificationMixin.js";
import SpinnerLoaderComp from '@/components/SpinnerLoaderComp.vue';
import {mapState} from "vuex";
import ProjectKpiComp from "@/components/ProjectKpiComp";
import ModalProjectManagementComp from "@/components/ModalProjectManagementComp";
import i18nMixin from "@/mixins/i18nMixin";
import TrackingMixin from "@/mixins/TrackingMixin";

export default {
  name: 'ProjectDetailsView',
  data: function () {
    return {
      locale: this.$route.params.locale,
      project: {}, // Object le projet à afficher dans la view

      // pour les composants où l'user est identifié ///////////////////////
      organizationSlug: this.$route.params.organization,
      // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug
      componentIsReady: false, // indique quand le composant est prêt à être afficher
      isDemoMode: true, // Bool indique si le compopsant doit afficher des données de démonstration
      premiumLimitation: false, //Bool vaut true si l'accès au dashboard projet est interdit (= si l'api à retournée un status 402 'payment required' au moment de l'accès au dashboard du projet )
      // exemple basé sur un tarif horaire de 60€
      demoProject: {
        "slug": "demo-project-slug",
        "name": "Demo Project",
        "client": null,
        "organization": [],
        "isPrivate": true,
        "isArchived": false,
        "color": "90a4ae",
        "owner": {
          "slug": "fusajiro-nintendo-jp",
          "name": "Yamushi",
          "firstname": "Fusajiro",
          "createdAt": "2021-11-19T13:07:34+00:00"
        },
        "durationDetailed": {
          "billable": "P0Y0M0DT50H0M0S",
          "nonBillable": "P0Y0M0DT7H15M0S",
          "all": "P0Y0M0DT57H15M0S"
        },
        "remainingTime": "P0Y0M0DT43H0M0S",
        "cost": {
          "billable": 3000,
          "nonBillable":120 ,
          "currency": "EUR"
        },
        "initialTime": 60,
        "workspaces": [
          {
            "slug": "nintendo-workspace",
            "createdAt": "2021-11-24T18:10:13+00:00"
          }
        ],
        "estimate": 100,
        "createdAt": "2021-11-24T11:20:56+00:00",
        "duration": "P0Y0M0DT57H0M0S"
      }
      // =================================================================
    }
  },
  computed: {
    // computed props for store :
    ...mapState({
      currentPeriod: state => state.ReportView.currentPeriod,
      themeToDisplay: state => state.app.themeToDisplay
    }),

    //----------------------------------------------
    // other computed props :

    projectSlug: { // le nom de la période (récupérée dans la route)
      get: function () {
        return this.$route.params.project
      },
      // set: function (newValue) {this.foo = newValue}
    },
    //----------------------------------------------


  },
  // watch: {
  //     // à chaque fois que la prop computed change, cette fonction s'exécutera
  //     user: function () {
  //     }
  // },
  components: {
    ModalProjectManagementComp,
    ProjectKpiComp,
    AppLayoutComp, SpinnerLoaderComp
    // Component,
  },
  mixins: [VueMetaMixin, SentryMixin, InterceptorMixin, GlobalErrorNotificationMixin, i18nMixin, TrackingMixin],
  //==========================================================
  metaInfo() {
    return this.setMeta(this.$t("metaTitleProjectDetails", {"project": this.project.name}), this.$t("metaDescProjectDetails"))
  },
  //==========================================================
  methods: {

    /**
     * Déclenche l'impression du navigateur
     **/
    printPage() {
      window.print()
      let msg = "Project Dashboard Printed"
      this.$mixpanel.track(msg, {"project": project.slug, "workspace": this.$auth.getActiveWorkspace()});
      this.ga4GlobalEventTrack(msg , {"project": project.slug, "workspace": this.$auth.getActiveWorkspace()})

    },

    /**
     * Récupère le projet
     *
     * @param String le slug du projet à charger
     */
    loadProject(projectSlug) {
      let self = this;
      self.$http.get(
          `organizations/${self.$auth.getOrganization()}/projects/${this.projectSlug}`,
          {
            params: {
              // withDuration: '', // on récupère la durée du projet
              withDurationDetailed: '', // on récupère la durée détaillée du projet
              withCost: '', // on récupère le coût du projet
            },
            headers: {Authorization: self.$auth.header()},
            timeout: 20000 // surcharge timeout car la requête a tendance à prendre du temps @todo à améliorer à terme ?

          }
      )
          .then(function (response) {
            self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur


            self.project = response.data
            self.project.duration = response.data.durationDetailed.all // ProjectMixin à besoin de la prop project.duration (car on a économisé le query param withDuration)
            // stockage dans le store
            // self.$store.commit('UpdateProjectsViewProjects', response.data)
            self.componentIsReady = true
            self.premiumLimitation = false;
            self.isDemoMode = false;

          })
          .catch(function (error) {
            // On catch ici sauf ce qui relève des intercepteurs Axios
            if (self.shouldBeIntercepted(error.response, self.$auth) === false) {

              if (error.response.status === 402) { // si retour "payment required"
                self.displayDemoMode()
                self.premiumLimitation = true;
              }
              else{
                self.logToSentry(self, error, 'error')
                let errorCode = '0054'
                let errorDetails = "error fetching projects"
                self.showGlobalErrorNotif(self, errorCode)
                self.$mixpanel.track('global error displayed', {"id": errorCode, "detail": errorDetails})
                self.$gtag.exception({'description': 'error ' + errorCode + ' | ' + errorDetails, 'fatal': false})

                self.$sentry.captureMessage(`Error ${errorCode} > "${errorDetails} : ${error}`, 'error')
              }


            }
          })
          .then(() => {
            // toujours exécuté
            self.componentIsReady = true
          })
    },

    /**
     * Ouvre la modal project management pour modifier un projet
     * @param projectToModify L'objet Projet à modifier
     */
    modifyProject(projectToModify) {
      this.$root.$emit('show_modal_project_management', 'edition', projectToModify)
    }

    /**
     * Affiche la project details view en mode démo.
     * Par exemple utilisé lorsque l'utilisateur n'a pas de compte premium pour afficher une démonstration.
     **/
    , displayDemoMode(){
        this.componentIsReady = true
        this.project = this.demoProject
        this.project.name = this.$route.params.project
        this.isDemoMode=true
    }

  },
  created: function () {
  },
  mounted: function () {
    this.loadProject(this.$route.params.project)

    // listener de l'event project_edited, pour recharger le projet si on le modifie dans la modalProjectManagement depuis cette page
    let self = this
    this.$root.$on('project_edited', (projectEdited) => {
      self.componentIsReady = false
      self.loadProject(projectEdited.slug)
    })


  },
  beforeDestroy() {
  },
}
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
/*ATTENTION : css non "scoped" s'applique à tout le html*/

@media print {
  // masquage pour inpression
  .AppMenu, #appMenu {
    display: none;
  }
  #footer {
    display: none
  }
  .kpi {
    font-size: 18pt !important;
  }
  h4 {
    font-size: 9pt !important;
    color: #999 !important;

    .mainIcon {
      font-size: 10pt !important;
    }
  }
  #ProjectKpiComp {
    box-shadow: none !important;
    border: solid 1px #ccc;
  }
  progress {
    color-adjust: exact;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact; // garde les couleurs pour l'impression de la progress bar
  }
  .mainIcon {
    color: #eee !important;
  }
}

</style>

<style scoped lang="scss">
@import "../assets/css/globalVar.scss";
@import "../assets/css/bulmaResponsiveDep.scss";

#ProjectDetailsView {

  //////////////////////////////////////////
  // LIGHT THEME ///////////////////////////
  #printBtn {
    margin-left: .5rem;
  }

  .projectNamePart {
    //display: flex;
    //align-items: center;
    text-align: center;
    //justify-content: center;
    //border: dashed 1px white; //@todo supre
    padding: 1.5rem;


    .projectName {
      font-weight: bold;
      color: #666;
      font-size: 2rem;
      @include touch {
        font-size: 1.7rem;
        margin-top: 1rem;
      }

      .archivedMention {
        //font-size: 2rem;
        color: #ccc
      }

      .icon {
        $size: 2.7rem;
        height: $size;
        width: $size;
        margin-right: .3rem;
        vertical-align: text-bottom;
        color: #ccc; // pour l'icon si projet archivé
        @include touch {
          $size: 2rem;
          height: $size;
          width: $size;
        }
      }
    }

    .clientName {
      margin-left: .5rem;
      font-size: 1.2rem;
      font-weight: bold;
      color: #ccc;
      //
      //&::before {
      //  content: "-";
      //}

      .icon {
        margin: 0 0 0 .5rem;
        height: 1.2rem;
        width: 1rem;
      }
    }

  }

  h3 {
    color: #999;
    margin: 0 auto 1rem;
    text-align: left;
    font-weight: bold;
  }

  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {
    .upgradeMsg .message{
      background-color: $darkYellow !important;
      .message-body{
        p{color: $white !important;}
        .help{color:lighten($darkLightBlue,20%);}

        .upgradeLink{color: $brandPremium !important;}
      }
    }

    .projectNamePart {

      .editLink {
        a {
          color: lighten($darkBg, 10%);
        }
      }

      .projectName {
        color: $darkContrastTxt;

        .archivedMention {
          color: lighten($darkBg, 10%);
        }

        .icon {
          color: lighten($darkBg, 20%); // pour l'icon si projet archivé
        }
      }

      .clientName {
        color: lighten($darkBg, 20%);;
      }
    }

  }

}

</style>
